var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tags",staticClass:"filter-badges"},_vm._l((_vm.tags),function(tag){return _c('BBadge',{staticClass:"filter-badge",attrs:{"variant":"primary"}},[_vm._v(_vm._s(tag))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }